var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor google-business-reply-review" },
    [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.googleBusinessReplyReviewChannelId"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Google Business Channel ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.channelId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "channelId", $$v)
              },
              expression: "clone.channelId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "auto.googleBusinessReplyReviewYanTVerilecekYorumunBulunduUKanalIdsi"
                )
              )
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.googleBusinessReplyReviewReviewId"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Google Business Review ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.reviewId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "reviewId", $$v)
              },
              expression: "clone.reviewId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v(
              _vm._s(
                _vm.$t("auto.googleBusinessReplyReviewYanTVerilecekYorumunIdsi")
              )
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.googleBusinessReplyReviewYanTMetni"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Yanıt metni giriniz...",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.text,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "text", $$v)
              },
              expression: "clone.text",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }